/**
 * Categorias que salian en la anterior implementacion:
 * - Health Professional Events
 * - INC Events
 * - INC Online Events
 * - INC Symposia
 * - Industry Events
 */

export enum EventCategory {
  INC_EVENTS = "inc-events",
  INDUSTRY_EVENTS = "industry-events",
  INC_ONLINE_EVENTS = "inc-online-events",
  LATEST = "latest",
  PAST = "past"
}

export const eventCategories = Object.keys(EventCategory).map((name) => EventCategory[name as keyof typeof EventCategory]);

export function getEventCategoryLabel(category: EventCategory) {
  const labels = {
    "inc-events": "INC Events",
    "industry-events": "Industry Events",
    "inc-online-events": "INC Online Events",
    "latest": "Latest",
    "past": "Past Events",
  };

  return labels[category]
}
